import { isPlatformBrowser } from "@angular/common";
import { inject, InjectionToken, PLATFORM_ID } from "@angular/core";
import { ENVIRONMENT } from "@shared/tokens/environment.token";
import { AuthConfig } from "angular-oauth2-oidc";

/**
 * Gets the authentication configuration for the application.
 * 
 * @returns {AuthConfig} The authentication configuration object.
 */
export function getAuthConfig(): AuthConfig {
    const platformId = inject(PLATFORM_ID);
    const environment = inject(ENVIRONMENT);
    const isBrowser = isPlatformBrowser(platformId);

    return {
        // Url of the Identity Provider
        issuer: environment.idpServerUrl,

        strictDiscoveryDocumentValidation: false,

        // URL of the SPA to redirect the user to after login
        redirectUri: isBrowser ? window.location.origin : '',

        // The IdP's END-SESSION endpoint — pointing this at the SPA origin (the old value)
        // never told the IdP anything: the session cookie survived and the next visit
        // silently logged right back in
        logoutUrl: `${environment.idpServerUrl}connect/logout`,

        // Where the IdP sends the browser AFTER killing its session — registered on the
        // client (the seed adds every redirect uri as post-logout uri too)
        postLogoutRedirectUri: isBrowser ? window.location.origin : '',

        // The SPA's id. The SPA is registerd with this id at the auth-server
        // clientId: 'server.code',
        clientId: environment.loginClientId,

        // Just needed if your auth server demands a secret. In general, this
        // is a sign that the auth server is not configured with SPAs in mind
        // and it might not enforce further best practices vital for security
        // such applications.
        // dummyClientSecret: 'secret',
        responseType: 'code',

        // set the scope for the permissions the client should request
        // The first four are defined by OIDC.
        // Important: Request offline_access to get a refresh token
        // The api scope is a usecase specific one
        scope: 'openid profile offline_access',

        showDebugInformation: true,

        customQueryParams: {
            // SUPER_ADMIN
            // 'login_hint': environment.environmentName === 'DEV' ? 'julien.ambos@ja-developer.de' : ''
        }
    };
}